import {ElementSelector, saveJQuerySelector} from "@/shared/utils/misc";

export function setLoading(button: ElementSelector, text?: string, linkStyle = false) {
	button = saveJQuerySelector(button);
	const dataTag: string | undefined = button.data("loading-text") as string | undefined;
	if (dataTag == null) {
		const loadingText = text !== undefined ? text : messages["waitDialog.title"];
		let buttonContent = `<i class='far fa-spinner-third spinner ml-5 mr-5'></i> ${loadingText}`;
		if (linkStyle) {
			buttonContent = "<a>" + buttonContent + "</a>";
		}

		button.data("loading-text", buttonContent);
	}
	button.button("loading");
}

/**
 * Resets loading button, ends loading state
 * A reset text can be set to have a new button text after the reset
 * @param button
 * @param resetText string for the button text after reset
 */
export function resetLoading(button: ElementSelector, resetText?: string) {
	if (resetText) {
		saveJQuerySelector(button).data().resetText = resetText;
	}
	saveJQuerySelector(button).button("reset");
}

export function setResetText(button: ElementSelector, text: string) {
	saveJQuerySelector(button).data().resetText = text;
}


